export const getCurrentDate = () => {
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${year}-${month < 10 ? "0" : ""}${month}-${
    day < 10 ? "0" : ""
  }${day}`;
  return currentDate;
};

export const getDateOfLast = (days) => {
  let currentDate = new Date();
  let thirtyDaysAgo = new Date(currentDate);
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - days);
  let formattedDate = thirtyDaysAgo?.toISOString().split("T")[0];
  return formattedDate;
};

export const getCurrentTime = () => {
  const date = new Date();
  let hr = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let min =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  let sec =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  // This arrangement can be altered based on how we want the date's format to appear.
  let currenTime = `T${hr}:${min}:${sec}.000Z`;
  return currenTime;
};

export const normalizeDate = (input) => {
  if (!input) return null;

  // Try parsing with Date constructor first
  let date = new Date(input);

  // If parsing failed (Invalid Date), try replacing common delimiters
  if (isNaN(date.getTime())) {
    const cleanInput = input
      .replace(/[-.]/g, "/") // Replace - and . with /
      .replace(/\s+/g, " "); // Remove extra spaces
    date = new Date(cleanInput);
  }

  // Still invalid? Try parsing manually
  if (isNaN(date.getTime())) {
    const parts = input.match(/(\d{1,4})[^\d]+(\d{1,4})[^\d]+(\d{1,4})/);
    if (parts) {
      let [_, p1, p2, p3] = parts;
      // Decide which part is year/month/day
      if (p1.length === 4) {
        // YYYY-MM-DD or YYYY-DD-MM
        date = new Date(`${p1}-${p2}-${p3}`);
      } else if (p3.length === 4) {
        // DD-MM-YYYY or MM-DD-YYYY
        date = new Date(`${p3}-${p2}-${p1}`);
      }
    }
  }

  // Final check
  if (isNaN(date.getTime())) return null;

  // Format YYYY-MM-DD
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const normalizeTenDigitDate = (inputDate) => {
  try {
    if (!inputDate) return "";

    // Replace / with - for consistency
    const dateStr = inputDate.replace(/[\s./]+/g, "-").trim();

    // Split parts
    const parts = dateStr.split("-");

    let day, month, year;

    if (parts[0].length === 4) {
      // Format: YYYY-MM-DD
      [year, month, day] = parts;
    } else if (parts[2].length === 4) {
      // Assume DD-MM-YYYY
      [day, month, year] = parts;
    } else {
      throw new Error("Unrecognized date format: " + inputDate);
    }

    // Pad day and month with leading 0
    day = day.padStart(2, "0");
    month = month.padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error normalizing ten-digit date:", error);
    return "";
  }
};
